<app-nav></app-nav>
<section class="add-insurances">
  <div class="container">
    <div class="col">
      <form name="add-insurance-form">
        <div class="col top-gap-md">
          <div class="input-group">
            <div class="input-group addon">
              <input type="text" class="form-control" placeholder="Policy Type" name="policyType" #policyType="ngModel" [(ngModel)]="data.policyType">
              <span class="input-group-addon" id="basic-addon-policy"><img
                  src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <input type="text" class="form-control" placeholder="Insurer" name="insurer" #insurer="ngModel" [(ngModel)]="data.insurer">
              <span class="input-group-addon" id="basic-addon-insurer"><img
                  src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <input type="text" class="form-control" placeholder="Policy Number" name="policyNumber" #policyNumber="ngModel" [(ngModel)]="data.policyNumber">
              <span class="input-group-addon" id="basic-addon-policy"><img
                  src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <p-calendar [touchUI]="true"  [readonlyInput]="true" placeholder="Due Date" name="dueDate" #dueDate="ngModel" [(ngModel)]="data.dueDate"></p-calendar>
              <span class="input-group-addon" id="basic-addon-dueDate"><img
                  src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <input type="text" class="form-control" placeholder="Product Name" name="productName" #productName="ngModel" [(ngModel)]="data.productName">
              <span class="input-group-addon" id="basic-addon-product"><img
                  src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <input type="text" class="form-control" placeholder="Premium" name="premium" #premium="ngModel" [(ngModel)]="data.premium">
              <span class="input-group-addon" id="basic-addon-premium"><img src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <input type="text" class="form-control" placeholder="Sum Assured" name="sumAssured" #sumAssured="ngModel" [(ngModel)]="data.sumAssured">
              <span class="input-group-addon" id="basic-addon-sumAssured"><img
                  src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center" (change)="onFileChanged($event)" #imageInput>
            <img src="assets/images/cameraicon.png" width="50" (click)="fileInput.click()">
          </div>
          <div class="col text-center">
            <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput>
            <img src="assets/images/attachmenticon.png" width="50" (click)="fileInput.click()">
          </div>
        </div>
        <div class="row text-center top-gap-md">
          <div class="col">
            <h4 class="title">Add Reminder</h4>
          </div>
        </div>
        <div class="row top-gap-md">
          <div class="col-1">
            <label class="container-checkbox">
              <input type="checkbox" checked="checked">
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col">
            <input type="number" class="form-control input-days-reminder" name="daysBeforeDueDate" #daysBeforeDueDate="ngModel" [(ngModel)]="data.daysBeforeDueDate">
          </div>
          <div class="col-7">
            <label>Days before due date</label>
          </div>
          <div class="col">
            <img src="assets/images/redplusicon.png" width="20">
          </div>
        </div>
        <div class="row top-gap-md">
          <div class="col-1">
            <label class="container-checkbox">
              <input type="checkbox" checked="checked">
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col">
            <input type="number" class="form-control input-days-reminder" name="weeksBeforeDueDate" #weeksBeforeDueDate="ngModel" [(ngModel)]="data.weeksBeforeDueDate">
          </div>
          <div class="col-7">
            <label>Weeks before due date</label>
          </div>
          <div class="col">
            <img src="assets/images/redplusicon.png" width="20">
          </div>
        </div>
        <div class="row top-gap-md">
          <div class="col-1">
            <label class="container-checkbox">
              <input type="checkbox" checked="checked">
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col">
            <input type="number" class="form-control input-days-reminder" name="monthsBeforeDueDate" #monthsBeforeDueDate="ngModel" [(ngModel)]="data.monthsBeforeDueDate">
          </div>
          <div class="col-7">
            <label>Months before due date</label>
          </div>
          <div class="col">
            <img src="assets/images/redplusicon.png" width="20">
          </div>
        </div>
        <div class="row text-center top-gap-md bottom-gap-md">
          <div class="col">
            <button class="btn btn-common" routerLink="/insurances">Cancel</button>
          </div>
          <div class="col">
            <button class="btn btn-common" (click)="addInsuranceDetails();" data-toggle="modal"
            data-target="#addInsuranceModal">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal fade" id="addInsuranceModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
              <span [innerHtml]="successfullyAddedMessage" class=""></span>
          </div>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
        </div>

      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
  </div>
</section>